import { useState } from "react";

import { FormattedMessage } from "react-intl";

import { LoadingButton } from "@atlaskit/button";
import { FormFooter } from "@atlaskit/form";
import Heading from "@atlaskit/heading";
import { Box, Flex, Stack, xcss } from "@atlaskit/primitives";

import { experiments, useExperimentExposure } from "@/utils/experiment";

import { PageBoardColumnsLeftProps } from "../../../common/types.tsx";
import { useIsJFindInviteStepExperiment } from "../../../hooks/experiment-hooks.ts";

import messages from "./messages.tsx";
import { ColumnInputs, onClickFinishButton } from "./utils.tsx";

export const LeftHandSidePageBoardColumns = ({
    onClickNext,
    columnNames,
    setColumnNames,
    isBoardColumnsSubmitting
}: PageBoardColumnsLeftProps) => {
    const [emptyInputIndexes, setEmptyInputIndexes] = useState<number[]>([]);
    const [dupeIndexes, setDupeIndexes] = useState<number[]>([]);
    const [exceededInputLengthIndexes, setExceededInputLengthIndexes] =
        useState<number[]>([]);
    const isJfind1663ExperimentEnabled = useIsJFindInviteStepExperiment();

    // FIRE EXPOSURE FOR JFIND-1663 - first visible UX change is the CTA content on this page
    useExperimentExposure(experiments.jfindOnboardingWizardInviteStep);

    const onClickNextWrapper = ({ columnNames }: { columnNames: string[] }) => {
        onClickNext({ columnNames });
    };

    const buttonMsg = isJfind1663ExperimentEnabled ? (
        <FormattedMessage {...messages.nextButtonCta} />
    ) : (
        <FormattedMessage {...messages.finishButtonCta} />
    );

    return (
        <>
            <Stack space="space.200">
                <Heading size="xlarge" as="h1">
                    <FormattedMessage {...messages.title} />
                </Heading>
                <Box xcss={subtextStyles}>
                    <FormattedMessage {...messages.subtitle} />
                </Box>
                <ColumnInputs
                    columnNames={columnNames}
                    setColumnNames={setColumnNames}
                    emptyInputIndexes={emptyInputIndexes}
                    setEmptyInputIndexes={setEmptyInputIndexes}
                    dupeIndexes={dupeIndexes}
                    setDupeIndexes={setDupeIndexes}
                    exceededInputLengthIndexes={exceededInputLengthIndexes}
                    setExceededInputLengthIndexes={
                        setExceededInputLengthIndexes
                    }
                />
            </Stack>
            <FormFooter>
                <Flex
                    justifyContent="end"
                    alignItems="center"
                    xcss={footerStyles}
                >
                    <LoadingButton
                        appearance="primary"
                        onClick={() => {
                            onClickFinishButton({
                                onClickNext: onClickNextWrapper,
                                columnNames,
                                setEmptyInputIndexes,
                                setDupeIndexes,
                                setExceededInputLengthIndexes
                            });
                        }}
                        isLoading={isBoardColumnsSubmitting}
                        isDisabled={isBoardColumnsSubmitting}
                    >
                        {buttonMsg}
                    </LoadingButton>
                </Flex>
            </FormFooter>
        </>
    );
};

const subtextStyles = xcss({
    fontSize: "font.body.medium",
    color: "color.text.subtle"
});

const footerStyles = xcss({
    width: "100%",
    color: "color.text.subtlest"
});
